"use client";
import { removeProperty } from "@areahub/common";
import { SimpleGrid, Text } from "@chakra-ui/react";
import * as React from "react";
import { LockedStatCard } from "../../locked-stat-card";
import {
  ProgressStatCard,
  ProgressStatCardProps,
} from "../../progress-stat-card";
import { NoResultCard, NoResultCardProps } from "./no-results-card";
import { StatCard, StatCardProps } from "./stat-card";
import {
  StatSectionWrapperProps,
  StatsSectionWrapper,
} from "./stats-section-wrapper";

export interface StatSectionProps
  extends Omit<StatSectionWrapperProps, "children"> {
  title: string;
  subtitle: string;
  stats: (
    | StatCardProps
    | (Omit<StatCardProps, "value"> & { isPublic: boolean })
    | ProgressStatCardProps
  )[];
  colorScheme?: string;
  noRes?: NoResultCardProps;
  /**
   * Caption below the section's subtitle
   * @default "Click on a card to learn more about each hazard and what you can do about it."
   */
  caption?: string;
}
export const StatSection: React.FC<StatSectionProps> = ({
  stats,
  title,
  subtitle,
  colorScheme,
  noRes,
  knowledgeCenterSlug,
  caption,
}) => {
  return (
    <StatsSectionWrapper
      {...{ title, subtitle, colorScheme, knowledgeCenterSlug }}
    >
      {noRes ? (
        <NoResultCard {...noRes} />
      ) : (
        <>
          <Text color="white" fontSize="md" mb="20px" fontWeight="normal">
            {caption ??
              "Click on a card to learn more about each hazard and what you can do about it."}
          </Text>
          <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing="6">
            {stats.map(
              (
                stat:
                  | StatCardProps
                  | (Omit<StatCardProps, "value"> & { isPublic: boolean })
                  | ProgressStatCardProps,
                id: number,
              ) =>
                (stat as ProgressStatCardProps)?.caption ? (
                  <ProgressStatCard
                    key={id}
                    from="report-page"
                    {...(stat as ProgressStatCardProps)}
                    colorScheme={colorScheme}
                  />
                ) : (
                    stat as
                      | (Omit<StatCardProps, "value"> & { isPublic: boolean })
                      | ProgressStatCardProps
                  ).isPublic ? (
                  <LockedStatCard
                    key={id}
                    {...(removeProperty<
                      | (Omit<StatCardProps, "value"> & { isPublic: boolean })
                      | ProgressStatCardProps,
                      "isPublic"
                    >(stat, "isPublic") as Omit<StatCardProps, "value">)}
                    colorScheme={colorScheme}
                  />
                ) : (
                  <StatCard
                    key={id}
                    {...(stat as StatCardProps)}
                    colorScheme={colorScheme}
                  />
                ),
            )}
          </SimpleGrid>
        </>
      )}
    </StatsSectionWrapper>
  );
};
